// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrentTime_wrapper__l7kRI","date":"CurrentTime_date__-7LMX","currentTime":"CurrentTime_currentTime__Is2nR"};